import { SkeletonMetricCards } from '@/components/ui/skeleton'

export function RouteFallback() {
  return (
    <div className="space-y-6 animate-in fade-in duration-200" role="status" aria-busy="true" aria-label="Loading page content">
      <span className="sr-only">Loading page content...</span>
      <div className="space-y-2">
        <div className="skeleton h-7 w-48" />
        <div className="skeleton h-4 w-72" />
      </div>
      <SkeletonMetricCards count={4} />
      <div className="glass rounded-[var(--radius-md)] p-6">
        <div className="space-y-4">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="flex gap-4" style={{ animationDelay: `${i * 60}ms` }}>
              <div className="skeleton h-4 w-32" />
              <div className="skeleton h-4 flex-1" />
              <div className="skeleton h-4 w-24" />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
